export const invitationSteps = {
  orderedItems: ['detailFront', 'detailBack', 'envelope', 'recipients', 'addressing', 'rsvp', 'rsvpEnvelope', 'reviewPaper'],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'INVITATION',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'envelope',
    cardType: 'INVITATION',
    pageNumber: 1
  },
  envelope: {
    name: 'Envelope',
    to: 'envelope',
    next: 'rsvp',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0
  },
  recipients: {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressing: {
    name: 'Addressing',
    to: 'addressing',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressingPreview: {
    name: 'Addressing Preview',
    to: 'addressingPreview',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  rsvp: {
    name: 'RSVP Card',
    to: 'rsvp',
    next: 'rsvpEnvelope',
    cardType: 'RSVP',
    pageNumber: 0
  },
  rsvpEnvelope: {
    name: 'RSVP Envelope',
    to: 'rsvpEnvelope',
    next: 'reviewPaper',
    cardType: 'RSVP_ENVELOPE',
    pageNumber: 0
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const saveTheDateSteps = {
  orderedItems: ['detailFront', 'detailBack', 'envelope', 'recipients', 'addressing', 'reviewPaper'],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'envelope',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  envelope: {
    name: 'Envelope',
    to: 'envelope',
    next: 'reviewPaper',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0
  },
  recipients: {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressing: {
    name: 'Addressing',
    to: 'addressing',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressingPreview: {
    name: 'Addressing',
    to: 'addressingPreview',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const postcardSaveTheDateSteps = {
  orderedItems: ['detailFront', 'detailBack', 'recipients', 'addressing', 'reviewPaper'],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'reviewPaper',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  recipients: {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1,
  },
  addressing: {
    name: 'Addressing',
    to: 'addressing',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  addressingPreview: {
    name: 'Addressing',
    to: 'addressingPreview',
    next: 'detailBack',
    cardType: 'SAVE_THE_DATE',
    pageNumber: 1
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const thankYouSteps = {
  orderedItems: [
    'detailFront',
    'envelope',
    'reviewPaper'
  ],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'envelope',
    cardType: 'THANK_YOU',
    pageNumber: 0
  },
  envelope: {
    name: 'Envelope',
    to: 'envelope',
    next: 'reviewPaper',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0
  },
  recipients: {
    name: 'Guests',
    to: 'recipients',
    next: 'addressing',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressing: {
    name: 'Addressing',
    to: 'addressing',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  addressingPreview: {
    name: 'Addressing Preview',
    to: 'addressingPreview',
    next: 'envelope',
    cardType: 'INVITATION_ENVELOPE',
    pageNumber: 0,
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const menuSteps = {
  orderedItems: [
    'detailFront',
    'detailBack',
    'reviewPaper'
  ],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'MENU',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'reviewPaper',
    cardType: 'MENU',
    pageNumber: 1
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const detailSteps = {
  orderedItems: [
    'detailFront',
    'detailBack',
    'reviewPaper'
  ],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'DETAILS',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'reviewPaper',
    cardType: 'DETAILS',
    pageNumber: 1
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};

export const programSteps = {
  orderedItems: [
    'detailFront',
    'detailBack',
    'reviewPaper'
  ],
  detailFront: {
    name: 'Front',
    to: 'detailFront',
    next: 'detailBack',
    cardType: 'PROGRAM',
    pageNumber: 0
  },
  detailBack: {
    name: 'Back',
    to: 'detailBack',
    next: 'reviewPaper',
    cardType: 'PROGRAM',
    pageNumber: 1
  },
  reviewPaper: {
    name: 'Review',
    to: 'reviewPaper'
  }
};



// WEBPACK FOOTER //
// ./src/cards/util/customizationNavigation.js